var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ix-form-input-question',{attrs:{"title":_vm.$t('location')}}),_vm._v(" "),_c('v-select',{attrs:{"value":_vm.value,"items":_setup.activities,"label":_vm.$t('selectLocation'),"loading":_setup.loading,"solo":""},on:{"input":(val) => {
        if (_vm.iroId) {
          _setup.updateIRO({ iro: { id: _vm.iroId, activityId: val } })
        } else {
          _vm.$emit('update:value', val)
        }
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }